import { TimelineSegmentDataBase, TimelineSegmentContentDataBase } from '../ScattData.js';

class LabelData extends TimelineSegmentContentDataBase {
  constructor(label = '') {
    super();
    this.label = label;
  }

  static generateFromRawObj(labelDataRawObj) {
    return new this(labelDataRawObj['label']);
  }

  generateRawObj() {
    let labelDataRawObj = {};
    labelDataRawObj['label'] = this.label;
    return labelDataRawObj;
  }

  toString() {
    return this.label;
  }

  clone() {
    return new this.constructor(this.label);
  }

  isSameAs(that) {
    if (this.label !== that.label) return false;
    return true;
  }

  combine(that) {
    if (this.label.length === 0) {
      if (that.label.length > 0) this.label = that.label;
    } else {
      if (that.label.length > 0) this.label = `${this.label} ${that.label}`;
    }
  }
}

class LabelSegmentData extends TimelineSegmentDataBase {
  static contentData = LabelData;

  constructor(begin, end, labelData, isLocked) {
    super(begin, end, labelData, isLocked);
  }

  static toString() {
    return 'LabelSegmentData';
  }

  static get name() {
    return 'Label Data';
  }

  clone() {
    return super.clone(false);
  }
}

export default LabelSegmentData;
